import React from 'react';
import ExpiringCard from '../sales/ExpiringCard';
import WCActivity from '../mobileApp/Activity';
import { userRoles } from '../../../RoleProtected';
import EPActivity from '../expressPass/Activity';
import Usage from '../expressPass/Usage';
import Page from '../../../layout/Page';
import WashClubReport from '../mobileApp/WashClubReport';
import SubscriptionRedemptions from './SubscriptionRedemptions';
import Referral from './Referral';
import ClubShield from './ClubShield';
import { Features } from '../../../RequireFeature';
import KioskErrorResponses from '../KioskErrorResponses';
import { QuestRoute } from '../../../api/QuestRoutes';

const Index = ({ ...props }) => {

    return (
        <Page
            title='Subscriptions'
            icon='coins'
            tabs
        >
            <ExpiringCard tab='Expiring Card' roles={userRoles.viewAuditReports} />
            <WashClubReport tab='Wash Club Report' roles={userRoles.viewUsageReports} />
            <SubscriptionRedemptions tab='Subscription Redemptions' roles={userRoles.viewUsageReports} />
            <WCActivity tab='Wash Club Activity' roles={userRoles.viewUsageReports} />
            <EPActivity tab='ExpressPass Activity' roles={userRoles.viewUsageReports} />
            <Usage tab='ExpressPass Usage' roles={userRoles.viewUsageReports} />
            <Referral tab='Referral' roles={userRoles.viewUsageReports} />
            <ClubShield tab='Club Shield' roles={userRoles.viewCustomers} requiredFeatures={Features.PlateReads} />
            <KioskErrorResponses
                tab='Error Responses'
                dataRoute={QuestRoute.reports.kioskErrorResponseLog('loyalty')} 
                parentPage='SubscriptionReports'
                roles={userRoles.viewUsageReports}                
            />
        </Page >
    );
}

export default Index;